import { Component } from '@angular/core';
import { StorageService } from './core/storage/storageService';
import { AuthService } from './core/auth.service';
import { NavigationEnd, Router, RouterModule, Scroll } from '@angular/router';
import { filter, map, Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  title = 'Swipesum Gateway Portal';

  whichLayout: string = '';

  routerSubscription: Subscription | undefined = undefined;

  constructor(
    private storage: StorageService,
    private authService: AuthService,
    private router: Router,
  ) {
    //this.loadSettings();

    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.includes('signin') || event.url == '/') {
          this.whichLayout = 'open';
        } else if (event.url.includes('terminal')) {
          this.whichLayout = 'terminal';
        } else if (event.url.includes('merchant/account')) {
          this.whichLayout = 'merchant-admin';
        } else if (event.url.includes('my-account')) {
          this.whichLayout = 'merchant';
        } else {
          this.whichLayout = 'master';
        }
      }
    });
  }

  ngOnInit() {
    this.router.events
      .pipe(filter((event) => event instanceof Scroll))
      .subscribe(() => {
        this.storage.removeRoutingData();
      });

    // This is dumb. At least in Chrome, if you click a link that's attached to the router
    // but another control (like a text box) has focus, you have to click once to blur it
    // and a second time to activate the route (ie, follow the link).
    // This little nugget will force a click on an <a> tag on the first click.
    document.addEventListener('mousedown', (event) => {
      const activeElement = document.activeElement as HTMLElement;
      const targetElement = event.target as HTMLElement;

      if (targetElement.tagName === 'A') {
        activeElement.blur();
        targetElement.click();
      }
    });
  }

  /*
  async loadSettings() {

    await this.authService.getAllAccessNamespaces()
    .then(response => {
        this.storage.setAllAccessNamespaces(response)
    })
  }
*/
}
